import Vue from "vue";

Vue.filter("formatNumber", function(value, precision) {
  if (isNaN(value)) 
    return value;

  var power = Math.pow(10, precision || 0);
  return String(Math.round(value * power) / power);
});
